<app-alert-banner />
<router-outlet />
<app-ia-assistente />
